window.SUPERLINE_PRODUCTS = {
  APMS52: {
    sku: 'APMS52',
    variantId: 51747379773777,
    title: 'Sealey Superline PRO 2-Door Floor Cabinet',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS52_DFC1103560__79853.png?v=1761650427',
    url: 'https://workshoptoolstorage.co.uk/products/superline-pro-680mm-modular-cabinets-floor-drawer-sink-reel-multifunction-units-workshop-storage?variant=51747379773777'
  },
  APMS51: {
    sku: 'APMS51',
    variantId: 51747379806545,
    title: 'Sealey Superline PRO 4-Drawer Floor Cabinet',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS51_DFC1103264__02264.png?v=1756296494',
    url: ''
  },
  APMS59: {
    sku: 'APMS59',
    variantId: 51747379839313,
    title: 'Sealey Superline PRO 5-Drawer Floor Cabinet',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS59_DFC1260332__26017.png?v=1756393432',
    url: ''
  },
  APMS62: {
    sku: 'APMS62',
    variantId: 51747379872081,
    title: 'Sealey Superline PRO 7-Drawer Floor Cabinet',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS62_DFC1103268__65707.png?v=1756296516',
    url: ''
  },
  APMS57: {
    sku: 'APMS57',
    variantId: 51747379904849,
    title: 'Sealey Superline PRO Multi-Function Cabinet',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS57_DFC1103491__17584.png?v=1756297616',
    url: ''
  },
  APMS64: {
    sku: 'APMS64',
    variantId: 51754665214289,
    title: 'Sealey Superline PRO Wide 7-Drawer Floor Cabinet',
    type: 'base',
    width: 1360,
    bays: 2,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS64_WITH_TOP_DFC0850779__91599.png?v=1756376161',
    url: ''
  },
  APMS67: {
    sku: 'APMS67',
    variantId: 51747379937617,
    title: 'Sealey Superline PRO Sink Unit',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS67_DFC1260339__67300.png?v=1756393436',
    url: ''
  },
  APMS63: {
    sku: 'APMS63',
    variantId: 51747379970385,
    title: 'Sealey Superline PRO Reel Cabinet (3 Drawer)',
    type: 'base',
    width: 680,
    bays: 1,
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS63_DFC1103561__14404.png?v=1761650425',
    url: ''
  },

  APMS50UCS: {
    sku: 'APMS50UCS',
    variantId: 51754384949585,
    title: 'Single Upright Connector',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50UCS_DFC1103571__61909.png?v=1761650431',
    type: 'required'
  },
  APMS50UCD: {
    sku: 'APMS50UCD',
    variantId: 51754384982353,
    title: 'Double Upright Connector',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50UCD_DFC1103570__35837.png?v=1761650438',
    type: 'required'
  },
  APMS50BP: {
    sku: 'APMS50BP',
    variantId: 51754472964433,
    title: 'Standard Back Panel',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50BP_DFC1103569__46461.png?v=1761650457',
    type: 'required'
  },
  APMS60BP: {
  sku: 'APMS60BP',
  variantId: 51754472997201,
  title: 'Corner Back Panel 800mm',
  type: 'required',
  image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS60BP_DFC1103391__84230.png?v=1761648209'
},

  APMS53: {
    sku: 'APMS53',
    variantId: 51753285550417,
    title: 'Lift-Up Door Wall Cabinet',
    type: 'wall',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS53_DFC1103568__84548.png?v=1761650446',
    width: 680,
    bays: 1
  },
  APMS54: {
    sku: 'APMS54',
    variantId: 51753285583185,
    title: 'Tambour Front Wall Cabinet',
    type: 'wall',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS54_DFC1103567__22109.png?v=1761650441',
    width: 680,
    bays: 1
  },
  APMS65: {
    sku: 'APMS65',
    variantId: 51753285615953,
    title: '2-Door Wall Cabinet',
    type: 'wall',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS65_DFC1103563__52525.png?v=1761650429',
    width: 680,
    bays: 1
  },
  APMS68: {
    sku: 'APMS68',
    variantId: 51753285681489,
    title: 'Extra-Wide Wall Cabinet',
    type: 'wall',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS68_DFC1154621__46770.png?v=1756372234',
    width: 1360,
    bays: 2
  },
  APMS61: {
  sku: 'APMS61',
  variantId: 51753285714257,
  title: 'Corner Wall Cabinet 865mm',
  type: 'wall',
  image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS61__46373.png?v=1756372234',
  width: 865,
  bays: 1
},
APMS55: {
  sku: 'APMS55',
  variantId: 51747902128465,
  title: 'Sealey Superline PRO Single Door Tall Cabinet',
  type: 'tall',
  width: 600,
  bays: 0,
  image: 'https://workshoptoolstorage.co.uk/cdn/shop/files/APMS55_DFC0863527__44110.png',
  url: 'https://workshoptoolstorage.co.uk/products/superline-pro-full-height-modular-floor-cabinets-600mm-single-door-or-915mm-double-door-workshop-storage?variant=51747902128465'
},

APMS56: {
  sku: 'APMS56',
  variantId: 51747902161233,
  title: 'Sealey Superline PRO Double Door Tall Cabinet',
  type: 'tall',
  width: 915,
  bays: 0,
  image: 'https://workshoptoolstorage.co.uk/cdn/shop/files/APMS56_DFC0863533__66818.png',
  url: 'https://workshoptoolstorage.co.uk/products/superline-pro-full-height-modular-floor-cabinets-600mm-single-door-or-915mm-double-door-workshop-storage?variant=51747902161233'
},
  APMS69: {
    sku: 'APMS69',
    variantId: 51753285648721,
    title: 'Power Tool Rack 680mm',
    type: 'accessory',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS69_DFC1154627__24525.png?v=1756372234',
    width: 680,
    bays: 1
  },
  APMS70: {
    sku: 'APMS70',
    variantId: 51753285517649,
    title: 'Modular Shelf',
    type: 'accessory',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS70_DFC1132870__46090.png?v=1756372234',
    width: 680,
    bays: 1
  },
  APMS66: {
  sku: 'APMS66',
  variantId: 51748613849425,
  title: 'Superline PRO Modular Mobile Workshop Trolley',
  type: 'accessory',
  image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS66_DFC1103562__83220.png?v=1761650419',
  url: ''
},
APMS58: {
  sku: 'APMS58',
  variantId: 51748613882193,
  title: 'Superline PRO Modular Mobile Cabinet - 5 Drawer, 650mm',
  type: 'accessory',
  image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS58_DFC1260335__31947.png?v=1756393442',
  url: ''
},

  APMS50WA: {
    sku: 'APMS50WA',
    variantId: 51748312711505,
    title: 'Pressed Wood Worktop 680mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50WA__71198.png?v=1756307568',
    width: 680,
    finish: 'wood'
  },
  APMS50WB: {
    sku: 'APMS50WB',
    variantId: 51748312842577,
    title: 'Pressed Wood Worktop 1360mm',
    type: 'worktop',
   image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50WA__71198.png?v=1756307568',
    width: 1360,
    finish: 'wood'
  },
  APMS50WC: {
    sku: 'APMS50WC',
    variantId: 51748312908113,
    title: 'Pressed Wood Worktop 2040mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50WA__71198.png?v=1756307568',
    width: 2040,
    finish: 'wood'
  },
  APMS60PW: {
    sku: 'APMS60PW',
    variantId: 51748312777041,
    title: 'Pressed Wood Corner Worktop 865mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50WA__71198.png?v=1756307568',
    width: 865,
    finish: 'wood'
  },
  APMS50SSA: {
    sku: 'APMS50SSA',
    variantId: 51748312678737,
    title: 'Stainless Steel Worktop 680mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50SSA__88445.png?v=1756307531',
    width: 680,
    finish: 'stainless'
  },
  APMS50SSB: {
    sku: 'APMS50SSB',
    variantId: 51748312809809,
    title: 'Stainless Steel Worktop 1360mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50SSA__88445.png?v=1756307531',
    width: 1360,
    finish: 'stainless'
  },
  APMS50SSC: {
    sku: 'APMS50SSC',
    variantId: 51748312875345,
    title: 'Stainless Steel Worktop 2040mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50SSA__88445.png?v=1756307531',
    width: 2040,
    finish: 'stainless'
  },
  APMS60SS: {
    sku: 'APMS60SS',
    variantId: 51748312744273,
    title: 'Stainless Steel Corner Worktop 865mm',
    type: 'worktop',
    image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS50SSA__88445.png?v=1756307531',
    width: 865,
    finish: 'stainless'
  },
  APMS60: {
  sku: 'APMS60',
  variantId: 51748066328913,
  title: 'Sealey Superline PRO Corner Floor Cabinet',
  type: 'base',
  width: 865,
  bays: 1,
  image: 'https://cdn.shopify.com/s/files/1/0942/9211/5793/files/APMS60_DFC1103387__48841.png?v=1761648209',
  url: ''
}
};